import { Apis } from "../../../lib/Apis";

export const useSimilarBlogs = () => {
    const getSimilarBlogsData = async (setSimilarBlogsData, blogId) => {
        try {
            const response = await Apis.getSimilarItems({
                sourceId: blogId,
                sourceType: 'blog'
            });
            setSimilarBlogsData(response.data.data);
            return response.data.data;
        } catch (error) {
            console.error(error);
            return error;
        }
    };

    const getBlogsListingForSelection = async (setListingData, blogId, targetType = 'blog', search = "") => {
        try {
            const response = await Apis.getAdminSimilarItemsList({
                sourceId: blogId,
                sourceType: 'blog',
                targetType: targetType,
                search: search,
                limit: 100 
            });
            setListingData(response.data.data.items);
            return response.data.data.items;
        } catch (error) {
            console.error(error);
            return error;
        }
    };

    const addSimilarBlogs = async (sourceId, targetItems) => {
        try {
            // targetItems should be an array of { targetId, targetType }
            const response = await Apis.addSimilarItems({
                sourceId,
                sourceType: 'blog',
                targetItems
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const deleteSimilarBlog = async (sourceId, targetId, targetType) => {
        try {
            const response = await Apis.removeSimilarItem({
                sourceId,
                sourceType: 'blog',
                targetId,
                targetType
            });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    const updateSimilarBlogPosition = async (id, position) => {
        try {
            const response = await Apis.updateSimilarItemPosition({ id, position });
            return response.data;
        } catch (error) {
            console.error(error);
            throw error;
        }
    };

    return {
        getSimilarBlogsData,
        addSimilarBlogs,
        deleteSimilarBlog,
        getBlogsListingForSelection,
        updateSimilarBlogPosition,
    };
};
